<po-page-list
  p-title="Pré-cadastro Fornecedor"
  [p-breadcrumb]="breadcrumb"
  [p-filter]="filterSettings"
  [p-actions]="actionPage"
>

  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-height]="600"
    [p-hide-select-all]="true"
    [p-sort]="true"
    [p-striped]="true"
    [p-columns]="tabelaPrincipalColunas"
    [p-items]="tabelaPrincipalItens"
    [p-show-more-disabled]="tabelaPrincipalShowMoreDisable"
    (p-show-more)="tabelaPrincipalLoad(false)"
    p-actions-right="true"
    [p-actions]="tabelaPrincipalActions"
    p-spacing="small"
    [p-filter-type]="poSearchFilterMode"
    p-hide-table-search="false"
  ></po-table>
</po-page-list>

<po-modal #advancedFilterModal p-title="Filtros" [p-primary-action]="advancedFilterPrimaryAction">
  <form #f="ngForm">
    <po-input class="po-sm-12 po-md-4 po-lg-4"
      name="NCODIGO"
      p-label="Código"
      [(ngModel)]="tabelaPrincipalFiltro.dados.NCODIGO"
      p-clean="true"
    ></po-input>
    <po-multiselect class="po-sm-12 po-md-12 po-lg-12"
      name="CSTATUS_IN"
      p-label="Status"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CSTATUS_IN"
      [p-options]="tabelaPrincipalFiltro.CSTATUSlista"
      [p-required]="true"
    ></po-multiselect>
    <po-select class="po-sm-12 po-md-4 po-lg-4"
      name="CURGENTE"
      p-label="Urgente"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CURGENTE"
      [p-options]="tabelaPrincipalFiltro.CURGENTElista"
      [p-required]="true"
    ></po-select>
    <po-datepicker class="po-sm-12 po-md-4 po-lg-4"
      name="DINCLUSAO_DE"
      p-label="Inclusão de:"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DINCLUSAO_DE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
    ></po-datepicker>
    <po-datepicker class="po-sm-12 po-md-4 po-lg-4"
      name="DINCLUSAO_ATE"
      p-label="Inclusão até:"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DINCLUSAO_ATE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
    ></po-datepicker>
    <po-lookup class="po-sm-12 po-md-12 po-lg-12"
      p-label="Usuário Solicitante"
      name="CUSUARIO"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CUSUARIO"
      p-field-label="CUSRNOME"
      p-field-value="CUSRID"
      [p-columns]="usuarioColumnsFilters"
      [p-field-format]="usuarioFieldFormaterFilters"
      [p-filter-service]="usuarioLookupService"
      [p-advanced-filters]="usuarioAdvancedFilters"
      [p-literals]="{ modalTitle: 'Usuário' }"
    ></po-lookup>
  </form>
</po-modal>
